let lastKnownScrollPosition = 0;
let ticking = false;

function doSomething(scrollPos, direction) {
  let bodyEl = document.getElementsByTagName("body")[0];

  if (direction == "down" && scrollPos >= 80) {
    bodyEl.classList.add("is-scrolled");
    bodyEl.classList.remove("is-scrolling");
  } else if (scrollPos >= 80) {
    bodyEl.classList.add("is-scrolling");
    bodyEl.classList.remove("is-scrolled");
  } else {
    bodyEl.classList.remove("is-scrolled");
    bodyEl.classList.remove("is-scrolling");
  }
}

// Check scroll position and apply appropriate nav state
// Export this function so it can be called from other components
window.applyNavStateBasedOnScroll = function applyNavStateBasedOnScroll() {
  // Use a slight delay to ensure DOM elements are ready
  setTimeout(() => {
    const bodyEl = document.getElementsByTagName("body")[0];
    const navbarToggler = document.querySelector(".navbar-toggler");
    const navbarContainer = document.querySelector(".navbar--container");
    const scrollPosition = window.scrollY;

    if (bodyEl) {
      if (scrollPosition >= 80) {
        // User has scrolled - hide the banner/nav
        bodyEl.classList.add("is-scrolled");
        bodyEl.classList.remove("is-scrolling");
      } else {
        // User hasn't scrolled - show the banner
        bodyEl.classList.remove("is-scrolled");
        bodyEl.classList.remove("is-scrolling");
      }

      // Always ensure menu is closed (not expanded)
      bodyEl.classList.remove("menu-is-open");
    }

    // Always ensure menu toggler and container are in closed state
    if (navbarToggler) {
      navbarToggler.setAttribute("aria-expanded", "false");
    }
    if (navbarContainer) {
      navbarContainer.setAttribute("aria-hidden", "true");
    }

    // console.log(
    //   `Nav state applied: scrolled=${
    //     scrollPosition >= 80
    //   }, position=${scrollPosition}`
    // );
  }, 100); // Small delay to ensure DOM is ready
};

// Run on DOM content loaded
if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    window.applyNavStateBasedOnScroll
  );
} else {
  window.applyNavStateBasedOnScroll();
}

// Also run on window load as a fallback
window.addEventListener("load", window.applyNavStateBasedOnScroll);

document.addEventListener("scroll", function (e) {
  scrollDirection = lastKnownScrollPosition < window.scrollY ? "down" : "up";
  lastKnownScrollPosition = window.scrollY;

  if (!ticking) {
    window.requestAnimationFrame(function () {
      doSomething(lastKnownScrollPosition, scrollDirection);
      ticking = false;
    });

    ticking = true;
  }
});
